export const segmentLengthByZoom = (zoom: number) => {
  return zoom >= 10 && zoom < 11.5 ? 5 : Math.max(Math.round(Math.exp(-(Math.round(zoom) / 2) + 5)) * 10, 1)
}
